import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';

import BaseTrigger from './BaseTrigger';

import { trackAction } from 'util/analytics';

const baseString = 'vra-delete-trigger';
const DeleteTrigger = ({
  className,
  disabled,
  scriptId,
  onClickDeleteTrigger
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: !!className
  });

  return (
    <BaseTrigger
      className={classString}
      content={getMessage('button-text__delete')}
      dataTestId={baseString}
      disabled={disabled}
      handler={() => {
        trackAction(`Clicked on delete prescription, Rx: ${scriptId}`);
        onClickDeleteTrigger(scriptId); }}
    />
  );
};

DeleteTrigger.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  onClickDeleteTrigger: propTypes.func.isRequired,
  scriptId: propTypes.string.isRequired
};

export default DeleteTrigger;
